import { AxiosService, ResponseService } from './';

const getProjectList = async (_perPage, _page, commonSearch, sortBy) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/projects',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        sortBy: sortBy,
      },
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const projectInvesterList = async (_perPage, _page, _searchData, _sortBy) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/projects',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: _searchData,
        sortBy: _sortBy,
      },
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getMintingList = async (
  _perPage,
  _page,
  commonSearch,
  sortBy,
  projectId,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/projects/minting_list',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        sortBy: sortBy,
        projectId: projectId,
      },
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getProjectDetails = async (_projectId) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/projects/' + _projectId,
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getCategory = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/project_types',
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const createProject = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/projects/',
      isAuthorized: true,
      isMultipart: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getAllProjects = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/projects',
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const publishProject = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/projects/publish',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const updateProjectStatus = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/projects/update_status',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const mintTokens = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/projects/mint_tokens',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const projectFreezeUnfreeze = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/projects/freeze_unfreeze',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const checkSymbol = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/projects/check_symbol_exists',
      isAuthorized: true,
      formData: _formData,
      allowRequestCancellation: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const updateProject = async (_projectId, _formData) => {
  try {
    let axiosData = {
      method: 'put',
      url: 'admin/projects/' + _projectId,
      isAuthorized: true,
      isMultipart: true,
      formData: _formData,
    };

    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const deploy = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/projects/deploy',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const checkProjectSupply = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/projects/check_supply',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

export {
  getProjectList,
  getProjectDetails,
  getCategory,
  createProject,
  publishProject,
  updateProjectStatus,
  checkSymbol,
  updateProject,
  mintTokens,
  getMintingList,
  deploy,
  projectInvesterList,
  checkProjectSupply,
  projectFreezeUnfreeze,
  getAllProjects,
};
